// https://www.owasp.org/index.php/Password_special_characters
export const SPECIAL_CHARS = '!"#$%&\'()*+,-./:;<=>?@[]^_`{|}~';

export const USER_ORGANIZATION_TYPE = {
  EXTERNAL: 'EXTERNAL',
  INTERNAL: 'INTERNAL'
};

export const UNKNOWN_USER_TYPE = 'UNKNOWN_USER_TYPE';

export const AUTH_TYPE = {
  EMAIL: 'EMAIL',
  USERNAME: 'USERNAME'
};

export const AUTH_METHOD_TYPE = {
  DEFAULT: 'DEFAULT',
  MICROSOFT: 'MICROSOFT',
  GOOGLE: 'GOOGLE'
};

export const PRIVILEGES = {
  I_CREATE: 'I_CREATE',
  I_EDIT: 'I_EDIT',
  I_VIEW: 'I_VIEW',
  FORCE_USER_ACTIVATE: 'FORCE_USER_ACTIVATE',
  ALLOW_DEACTIVATING_SUSPENDED_USERS: 'ALLOW_DEACTIVATING_SUSPENDED_USERS',
  ACCESS_AUTH3_API: 'ACCESS_AUTH3_API',
  I_DELETE: 'I_DELETE',
  I_DEACTIVATE: 'I_DEACTIVATE',
  I_VIEW_AUDITS: 'I_VIEW_AUDITS',
  I_VIEW_SESSION_HISTORY: 'I_VIEW_SESSION_HISTORY',
  I_VIEW_ROLES: 'I_VIEW_ROLES',
  I_MODIFY_ROLES: 'I_MODIFY_ROLES',
  CREATE_DEFAULT_USER: 'CREATE_DEFAULT_USER',
  E_CREATE: 'E_CREATE',
  E_EDIT: 'E_EDIT',
  E_VIEW: 'E_VIEW',
  E_DELETE: 'E_DELETE',
  E_DEACTIVATE: 'E_DEACTIVATE',
  RESET_PASSWORD: 'RESET_PASSWORD',
  E_VIEW_AUDITS: 'E_VIEW_AUDITS',
  E_VIEW_SESSION_HISTORY: 'E_VIEW_SESSION_HISTORY',
  E_VIEW_ROLES: 'E_VIEW_ROLES',
  E_MODIFY_ROLES: 'E_MODIFY_ROLES',
  CREATE_USERS_WITHOUT_EMAIL: 'CREATE_USERS_WITHOUT_EMAIL',
  CREATE_ROLE: 'CREATE_ROLE',
  EDIT_ROLE: 'EDIT_ROLE',
  VIEW_ROLE: 'VIEW_ROLE',
  DELETE_ROLE: 'DELETE_ROLE',
  DEACTIVATE_ROLE: 'DEACTIVATE_ROLE',
  VIEW_ROLE_AUDITS: 'VIEW_ROLE_AUDITS',
  BULK_ASSIGN_ROLES: 'BULK_ASSIGN_ROLES',
  BULK_REMOVE_ROLES: 'BULK_REMOVE_ROLES'
};

export const PROPERTY_NAME = {
  CRED: 'cred',
  AUTHENTICATION_TYPE: 'authenticationType'
};

export const HTTP_STATUS_CODE = {
  unauthorized: 401
};

export const VIEW_MODE = {
  create: 0,
  edit: 1,
  copy: 2
};

export const HOME_COLOR_SCHEME = {
  error: '#F6787C',
  warning: '#622A2C'
};

export const RESPONSE_STATUS = {
  SUCCESS: 200
};

export const RESPONSE_STATUS_FLAG = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

export const ENV_URLS = {
  STAGE1: {
    url: 'https://aero-suite-stage1-airarabia.isaaviation.net',
    tag: 'GTM-TP9XN8VX'
  },
  STAGE2: {
    url: 'https://aero-suite-stage2-airarabia.isaaviation.net',
    tag: 'GTM-WR255CCF'
  },
  STAGE3: {
    url: 'https://aero-suite-stage3-airarabia.isaaviation.net',
    tag: 'GTM-W3R4NNDP'
  },
  STAGE4: {
    url: 'https://aero-suite-stage4-airarabia.isaaviation.net',
    tag: 'GTM-KX3LVR9K'
  },
  STAGE5: {
    url: 'https://aero-suite-stage5-airarabia.isaaviation.net',
    tag: 'GTM-WRWTLMCZ'
  },
  STAGE6: {
    url: 'https://aero-suite-stage6-airarabia.isaaviation.net',
    tag: ''
  },
  PROD: {
    url: 'https://aero-suite-prod-airarabia.accelaero.com',
    tag: 'GTM-M2W2TC79'
  },
  S9_STAGE1: {
    url: 'https://aero-suite-stage1-starsairways.isaaviation.net',
    tag: 'GTM-NCXFNZMV'
  },
  W5_STAGE1: {
    url: 'https://aero-suite-stage1-mahan.isaaviation.net',
    tag: 'GTM-KPD5LKBP'
  },
  S9_PROD: { url: '', tag: '' },
  W5_PROD: { url: '', tag: '' }
};
